<template>
    <el-image :src="imgSrc" :preview-src-list="[previewSrc]" style="width: 30px; height: 30px"></el-image>
</template>

<script>
    import { getImageUrl} from "../filters/CommonActions";
    export default {
        name: "PreviewImageComponent",
        data() {
            return {

            }
        },
        computed: {
            imgSrc() {
                return getImageUrl(this.value, '200x240')
            },
            previewSrc() {
                return getImageUrl(this.value)
            }
        },
        props: {
            value: {
                type: String,
                default: ''
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PreviewImageComponent.vue